module.exports = __webpack_public_path__ + "static/images/idCardExample-4.a8eb7d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/public/autoInsurance/idCardExample-4.png
// module id = apuN
// module chunks = 0